<template>
  <div class="cotent_con">
    <div class="content_top">
      <img src="@/assets/images/contact/banner.jpg" alt="" class="w100 pc" />
      <img
        src="@/assets/images/contact/banner_mobile.png"
        alt=""
        class="w100 mobile"
      />
      <!-- <h3>Contact Us</h3> -->
    </div>
    <div class="content_center">
      <div class="container">
        <h3 class="custom-title">Enquiries & Contact</h3>
        <div class="text_nr_box">
          <img src="@/assets/images/contact/img1.jpg" alt="" class="img1 pc" />
          <img
            src="@/assets/images/contact/img1_mobile.png"
            alt=""
            class="img1 mobile"
          />

          <ul>
            <li>
              <img src="@/assets/images/contact/icon_1.png" alt="" />

              <div class="text_box">
                <h4>Company: HISAN (Tianjin) Co., Ltd</h4>
              </div>
            </li>
            <li>
              <img src="@/assets/images/contact/icon_2.png" alt="" />
              <div class="text_box">
                <h4>EMail: HS@Hisantech.com</h4>
              </div>
            </li>
            <li>
              <img src="@/assets/images/contact/icon_3.png" alt="" />
              <div class="text_box">
                <h4>Tel: +86 22 84776558</h4>
              </div>
            </li>
            <li>
              <img src="@/assets/images/contact/icon_4.png" alt="" />
              <div class="text_box">
                <h4>
                  Address: NO.3, XinGang Wuhao Road, JinNan
                  District,TianJin,China
                </h4>
              </div>
            </li>
          </ul>
        </div>
        <h4>Customize your own wear solution now.</h4>
      </div>
    </div>
    <div class="content_bottom">
      <div class="container">
        <h3 class="custom-title">Enquiry Form</h3>
        <ul class="input_box">
          <li>
            <p>Name<span>*</span></p>
            <input type="text" v-model="name" />
          </li>
          <li>
            <p>Email<span>*</span></p>
            <input type="text" v-model="email" />
          </li>
          <li>
            <p>Phone<span>*</span></p>
            <input type="text" v-model="phone" />
          </li>
          <li>
            <p>Company<span>*</span></p>
            <input type="text" v-model="company" />
          </li>
        </ul>
        <div class="checkbox_box">
          <p>Area/s of Interest</p>
          <ul>
            <li>
              <input
                type="checkbox"
                value="CCO plate"
                v-model.number="interest"
                name="interest"
                id=""
              />
              CCO plate
            </li>
            <!-- <li>
							<input type="checkbox" value="AR steel plate" v-model.number="interest" name="interest" id="" />
							 AR steel plate</li> -->
            <li>
              <input
                type="checkbox"
                value="Bimetal Casting CWI"
                v-model.number="interest"
                name="interest"
                id=""
              />
              Overlay Wear Pipe
            </li>
            <!-- <li><input type="checkbox" value="Ni Hard Liners& Blocks" v-model.number="interest" name="interest" id="" /> High Chromium White Cast Iron</li>
						<li><input type="checkbox" value="Wear resistant ceramics" v-model.number="interest" name="interest" id="" /> Wear resistant ceramics</li>
						 -->
            <li>
              <input
                type="checkbox"
                value="Welding wire"
                v-model.number="interest"
                name="interest"
                id=""
              />
              Welding wire
            </li>
            <li>
              <input
                type="checkbox"
                value="Wear parts"
                v-model.number="interest"
                name="interest"
                id=""
              />
              Wear parts
            </li>
          </ul>
        </div>
        <div class="message_box">
          <p>Message</p>
          <textarea name="" v-model="message" id="message"></textarea>
        </div>
        <div class="button_submit" @click="submitinfo()">
          Send
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      company: "",
      interest: [],
      message: "",
    };
  },
  mounted() {
    this.$emit("loaded");
  },
  methods: {
    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return regex.test(email);
    },
    submitinfo() {
      console.log(this.interest);
      if (this.email == "" && this.isValidEmail(this.email)) {
        alert("Enter your email address");
      } else if (this.name == "") {
        alert("Enter your name");
      } else if (this.phone == "") {
        alert("Enter your phone");
      } else if (this.company == "") {
        alert("Enter your company");
      } else {
        console.log(this.useremail);
        axios({
          method: "post",
          url: `${this.$apiYf}/liuyanapi.php`,
          data: {
            email: this.email,
            name: this.name,
            phone: this.phone,
            company: this.company,
            interest: this.interest.toString(),
            message: this.message,
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          console.log(res);
          alert(res.data.des);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.cotent_con {
  @media (max-width: 768px) {
    .container {
      width: 90%;
      h4 {
        font-size: 15px !important;
      }
    }
    .content_top {
      img {
      }
    }
  }
  .content_center {
    width: 100%;
    h3 {
      font-size: 48px;
      color: #ad1f24;
      margin: 4vw 0 2.5vw;
      text-align: left;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    h4 {
      color: #ad1f24;
      font-size: 24px;
      margin-bottom: 10px;
    }
    @media (max-width: 1400px) {
      h4 {
        font-size: 20px;
      }
      p {
        font-size: 14px;
        line-height: 2;
      }
    }
    .text_nr_box {
      display: flex;
      align-items: flex-start;
      flex-direction: row-reverse;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        ul {
          width: 100%;
          li {
            width: 50px !important;
            height: 50px !important;
            h4 {
              font-size: 15px !important;
              width: 70vw !important;
            }
          }
        }

        .img1 {
          width: 100% !important;
          height: 100px;
          margin-bottom: 20px;
        }
      }
      ul {
        flex: 1;
        li {
          display: flex;
          align-items: center;
          margin-bottom: 3vw;
          img {
            background: #ad1f24;
            margin-right: 10px;
          }

          p {
            font-size: 18px;
            color: #333;
          }
        }
      }
      .img1 {
        width: 41.428%;
      }
    }
  }
  .content_bottom {
    position: relative;

    h3 {
      font-size: 48px;
      color: #ad1f24;
      margin: 4vw 0 2.5vw;
      text-align: left;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    p {
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      span {
        color: #d30000;
      }
    }
    .input_box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      @media (max-width: 768px) {
        li {
          width: 100% !important;
        }
      }
      li {
        width: 48%;
        margin-bottom: 2vw;
        @media (max-width: 768px) {
          p {
            font-size: 15px !important;
          }
          input {
            height: 30px !important;
            line-height: 30px !important;
          }
        }
        input {
          width: 100%;
          background: #efefef;
          border: none;
          outline: none;
          padding: 0 1%;
          height: 50px;
          line-height: 50px;
          &:focus {
            border: solid 1px #ad1f24;
          }
        }
      }
    }
    .checkbox_box {
      @media (max-width: 768px) {
        p {
          font-size: 15px !important;
        }
        ul {
          flex-wrap: wrap !important;
        }
        li {
          font-size: 12px !important;
          width: 100% !important;
          display: flex !important;
          align-items: center !important;
          input {
            margin-right: 10px !important;
            margin-top: 0 !important;
          }
        }
      }
      ul {
        display: flex;
        margin-bottom: 2vw;
        justify-content: space-between;
        font-size: 16px;
        color: #333;
      }
    }
    .message_box {
      @media (max-width: 768px) {
        p {
          font-size: 15px !important;
        }
        textarea {
          height: 100px !important;
        }
      }
      textarea {
        width: 100%;
        background: #efefef;
        height: 100px;
        border: none;
        outline: none;
        padding: 1%;
        &:focus {
          border: solid 1px #ad1f24;
        }
      }
    }
    .button_submit {
      font-size: 24px;
      color: #fff;
      line-height: 50px;
      height: 50px;
      width: 100%;
      text-align: center;
      background: #ad1f24;
      margin: 2vw 0 4vw;
      @media (max-width: 768px) {
        height: calc(60px / 2);
        width: calc(662px / 2);
        font-size: 15px !important;
        line-height: calc(60px / 2);
        margin: 10px auto;
      }
    }
  }
}
</style>
